import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Orientation, WriteDirection } from 'sofa-reborn-react';

type Attributes = {
	orientation: Orientation;
	writeDirection: WriteDirection;
};

function getArmrestPickerButtonStyling(props: Attributes): string {
	return props.orientation === 'portrait'
		? `
				height: 40px;
				flex-direction: column;
				justify-content: center;
				padding-right: ${props.writeDirection === 'rtl' ? '0' : '8px'};
				padding-left: ${props.writeDirection === 'rtl' ? '8px' : '0'};
				margin-top: 14px;
		  `
		: `
				height: 55px;
				justify-content: center;
				padding: ${props.writeDirection === 'ltr' ? '0 8px' : '0'};
				align-items: center;
		  `;
}

export const ArmrestPickerButtonStyle = styled.div<{
	orientation: Orientation;
	writeDirection: WriteDirection;
}>`
	display: flex;
	cursor: pointer;
	flex-direction: row;
	background-color: ${SkapaTheme.color.neutral.white};
	${(props) => getArmrestPickerButtonStyling(props)}
`;

export const SelectedArmrestStyle = styled.div`
	display: flex;
	height: 100%;
	align-items: center;
	justify-content: center;
	img {
		height: 40px;
	}
`;

export const ArmrestWrapper = styled.div<{
	isPortrait: boolean;
}>`
	${(props): string => `
		${getWrapperStyle(props.isPortrait)}
	`}
`;

function getWrapperStyle(isPortrait: boolean): string {
	return isPortrait
		? `
				display: flex;
				justify-content: center;
		  `
		: `
				display: block;
		  `;
}
